/** 跳转链接默认数据 */
export function createEmptyJumpLink() {
	return {
		type: '',
		type_name: '',
		url: '',
		original_url: '',
		appid: '',
		original_id: '',
		chat_path: '',
		chat_name: '',
		id_key: '',
		id: 0,
		qrcode_type: '',
		title: '',
	};
}

export function formatJumpLinkLabel(jumpLink) {
	if (!jumpLink?.type) {
		return '';
	}
	const name = jumpLink.title
		|| jumpLink.original_url
		|| jumpLink.chat_name
		|| jumpLink.type_name
		|| '';
	if (jumpLink.type_name && name && name !== jumpLink.type_name) {
		return `[${jumpLink.type_name}]${name}`;
	}
	return name || jumpLink.type_name || '已设置链接';
}

export function navigateJumpLink(jumpLink, { apiRequest } = {}) {
	if (!jumpLink?.type) {
		return;
	}
	switch (jumpLink.type) {
		case 'web':
			if (jumpLink.url) {
				window.location.href = jumpLink.url;
			}
			break;
		case 'tel':
			window.location.href = jumpLink.url || `tel:${jumpLink.original_url}`;
			break;
		case 'qrcode':
			if (jumpLink.id_key && apiRequest) {
				apiRequest.post('/api/liveCodeWebUrl', {
					id_key: jumpLink.id_key,
				}).then((res) => {
					if (res.data?.data) {
						window.location.href = res.data.data;
					}
				}).catch(() => {});
			}
			break;
		case 'chat':
			break;
		default:
			break;
	}
}
